import React, { useEffect } from 'react';
export const OutsideClick = (props) => {
    //const ref = useRef<HTMLDivElement>(null)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (props.reference.current &&
                !props.reference.current.contains(event.target)) {
                props.onOutsideClick();
            }
        };
        if (props.isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [props.isOpen]);
    return React.createElement(React.Fragment, null, props.children);
};
//# sourceMappingURL=OutsideClick.js.map